import React, { useState, useEffect } from "react";
import VehiculoAnioSelector from "~business/vehiculoAnioSelector/VehiculoAnioSelector";
import VehiculoModeloSelector from "~business/vehiculoModeloSelector/vehiculoModeloSelector";

const ANIO_STEP = "ANIO_STEP";
const MODELO_STEP = "MODELO_STEP";

interface VehiculoStepperProps {
  marca: string | null;
  onChange?: (anio: string, modelo: string, codia: string) => void;
}

const VehiculoStepper: React.FC<VehiculoStepperProps> = ({
  marca,
  onChange,
}) => {
  const [anio, setAnio] = useState<string | null>(null);
  const [modelo, setModelo] = useState<string | null>(null);
  const [codia, setCodia] = useState<string | null>(null);

  useEffect(() => {
    const allCompleted = anio && modelo && marca && codia;
    if (allCompleted && onChange) onChange(anio, modelo, codia);
  }, [marca, modelo, codia, anio, onChange]);

  const handleChangeValue = (event: {
    target: { value: { label: string | null; value: string | null } };
  }) => {
    const value = event.target.value;
    setModelo(value.label || "");
    setCodia(value.value || "");
  };

  const step = getStep(anio, modelo);

  return (
    <div style={{ minHeight: "90vh" }}>
      {step === ANIO_STEP && (
        <VehiculoAnioSelector
          value={{ label: anio, value: anio }}
          onChange={(event) => setAnio(event.target.value)}
        />
      )}
      {step === MODELO_STEP && (
        <VehiculoModeloSelector
          marca={{ label: marca, value: marca }}
          anio={{ label: anio, value: anio }}
          value={{ label: modelo, value: codia }}
          onChange={handleChangeValue}
        />
      )}
    </div>
  );
};

export default VehiculoStepper;

const getStep = (anio: string | null, modelo: string | null): string => {
  if (!anio) return ANIO_STEP;
  if (!modelo) return MODELO_STEP;
  return MODELO_STEP;
};
